(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ma-pinterest-welcome"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.maPinterestFormListener) return;
  window.maPinterestFormListener = true;
  const sent = new Set();
  const roots = () => document.querySelectorAll('[data-ma-pinterest]');
  const hasMarketingConsent = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  // Shopify's Pinterest app pixel is sandboxed. Load this signup-only tracker
  // after consent and a completed signup; never send page or purchase events.
  const signupTracker = () => {
    if (typeof window.pintrk === 'function') return window.pintrk;
    const track = function () { track.queue.push(Array.from(arguments)); };
    track.queue = [];
    track.version = '3.0';
    window.pintrk = track;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://s.pinimg.com/ct/core.js';
    document.head.appendChild(script);
    track('load', '2613608268686');
    return track;
  };
  const withPrivacy = callback => {
    if (window.Shopify?.customerPrivacy) return callback();
    window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => {
      if (!error) callback();
    });
  };
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    roots().forEach(root => {
      if (detail.formId !== root.dataset.formId) return;
      if (detail.type === 'embedOpen') root.querySelector('[data-form-fallback]')?.remove();
      if (detail.type !== 'submit') return;
      root.dataset.submitted = 'true';
      if (root.dataset.preview === 'true' || root.dataset.tracking !== 'true') return;
      root.dataset.trackingStatus = 'waiting-for-privacy';
      withPrivacy(() => {
      if (!hasMarketingConsent()) { root.dataset.trackingStatus = 'consent-not-allowed'; return; }
      const key = 'ma-pinterest-signup:' + detail.formId;
      try { if (sessionStorage.getItem(key)) { root.dataset.trackingStatus = 'already-sent'; return; } } catch (_) {}
      if (sent.has(key)) return;
      const eventId = 'ma-pinterest-' + crypto.randomUUID();
      signupTracker()('track', 'signup', {event_id: eventId, lead_type: 'Pinterest email signup'});
      root.dataset.trackingStatus = 'queued';
      sent.add(key);
      try { sessionStorage.setItem(key, eventId); } catch (_) {}
      });
    });
  });
  roots().forEach(root => root.querySelector('[data-cookie-preferences]')?.addEventListener('click', () => window.privacyBanner?.showPreferences()));
  const revealForm = () => roots().forEach(root => {
    if (root.querySelector('[class^="klaviyo-form-"] form')) root.querySelector('[data-form-fallback]')?.remove();
  });
  const observer = new MutationObserver(revealForm);
  observer.observe(document.documentElement, {childList:true,subtree:true});
  revealForm();
})();

  } catch(e) { console.error(e); }
})();
})();
